import type { JSX } from 'react';
import { Button, FormButtonRow } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';
import { ProcessActivityEditCancelButton } from './ProcessActivityEditCancelButton';

type ProcessActivityEditActionButtonRowProps = Readonly<{
    getSubmitButton?: () => JSX.Element;
    isDisabled: boolean;
    isModifying: boolean;
    onModifyActivity: () => Promise<void>;
    onSaveDraft: () => Promise<void>;
}>;

export function ProcessActivityEditActionButtonRow(props: ProcessActivityEditActionButtonRowProps): JSX.Element {
    const { getSubmitButton, isDisabled, isModifying, onSaveDraft, onModifyActivity } = props;

    return (
        <FormButtonRow>
            <ProcessActivityEditCancelButton isDisabled={isDisabled} />
            {isModifying ? (
                <Button
                    isDisabled={isDisabled}
                    onClick={onModifyActivity}
                    type="submit"
                >
                    {getSelectedLanguage().processActivity.applyModification}
                </Button>
            ) : (
                <>
                    <Button
                        isDisabled={isDisabled}
                        onClick={onSaveDraft}
                        variant="outline"
                    >
                        {getSelectedLanguage().common.saveDraft}
                    </Button>

                    {getSubmitButton ? (
                        getSubmitButton()
                    ) : (
                        <Button
                            isDisabled={isDisabled}
                            type="submit"
                        >
                            {getSelectedLanguage().request.saveSend}
                        </Button>
                    )}
                </>
            )}
        </FormButtonRow>
    );
}
